<template>
  <div class="test-sign-up">
    <div class="top">
      <img src="../../assets/img/img-sing-up-top.png" alt="" usemap="#suspension">
      <map name="suspension">
        <area shape="rect" coords="1080,16,1180,44" alt="点击报名" class="btn-add">
      </map>
    </div>
    <div class="main">
      <img src="../../assets/img/img-sing-up-left.png" alt="">
      <div class="content">
        <div class="title">
          <img src="../../assets/img/img-yaoqinghang.png" alt="">
        </div>
        <div class="text">
          <p style="text-indent: 0">全国各高中学校：</p>
          <p>为帮助各高中学校检验本校高三复习效果，帮助学生找到复习中存在的问题，满足全国师生在备考时各项需求，
            达到错因精准定位，排名精准评估，成绩精准提升的目的，风向标教育联合全国千余所高级中学，开展本次<span class="red">全学科、高保真</span>的高三联合质量评估考试。</p>
          <p>通过本次联合质量评估，学校可以清晰掌握本校复习各项指标，梳理各班、各层次学生的复习情况，为接下来的复习定标准、找方向。利用风向标智能精准教学系统，为每一所学校提供专项报告、每一名教师提供专属教案，每一位学生提供个性化提升方案。
            为了实现教师精准备考、学生个性化复习，风向标教育联合高考命题专家，举办线上联合评估质量分析会议，进一步明确复习亮点和不足，打造行之有效的精准复习备考策略。</p>
          <p class="text-title">一、报名方式</p>
          <p>知心慧学项目学校通过学管登录学管端进行考试报名；（学校告知在校学管报名）</p>
          <p>其他学校可以通过知心慧学官网提交报名信息，或者通过业务经理进行报名。</p>
          <p>采用邮箱报名：zhao@fxbjy.com</p>
          <p class="text-title">二、组织考试</p>
          <p>考试时间：2019年12月19日-20日（具体科目时间安排见下表）</p>
          <table class="table-sing-up" border="1">
            <tr class="table-head">
              <td colspan="4">考试时间安排</td>
            </tr>
            <tr>
              <td width="117px">适用范围</td>
              <td width="200px">时间</td>
              <td>上午</td>
              <td>下午</td>
            </tr>
            <tr>
              <td>全国</td>
              <td>12月19日</td>
              <td>语文  09:00-11:30</td>
              <td>数学（文理）  15:00-17:00</td>
            </tr>
            <tr>
              <td>全国</td>
              <td>12月20日</td>
              <td>文科综合/理科综合  09:00-11:30</td>
              <td>英语  15:00-17:00</td>
            </tr>
          </table>
          <p>为保证本次联合质量评估的公平、公正，参评学校名称在系统内均以<span class="red">特定代码的方式</span>呈现。系统<span class="red">提前2小时</span>发布试卷，由学管（或学校相关人员）按时下载并打印试卷、答题卡。</p>
          <p>考试结束后学管（或学校相关人员）扫描答题卡。</p>
          <p>参考学校的老师，在12月21日12点前完成所有线上阅卷（阅卷规则和时间<span class="red">详见附件1</span>）。</p>
          <p class="text-title">三、成绩报告</p>
          <p>2019年12月23日-24日，老师可以登录风向标智能精准教学系统（知心慧学）在线查看本校成绩报告，也可以在线查看本省整体综合报告。</p>
          <p class="text-title">四、联合质量分析会议</p>
          <p>2019年12月26日及27日举办线上质量分析会议，帮助学校进一步精准找到原因，明确本次联评存在的问题，结合今年高考预测，共同打造高效的二轮精准备考方案。（具体科目时间安排见下表）</p>
          <table class="table-sing-up" border="1">
            <tr class="table-head">
              <td colspan="4">线上质量分析会议时间安排</td>
            </tr>
            <tr>
              <td width="117px">适用范围</td>
              <td width="200px">时间</td>
              <td>上午</td>
              <td>下午</td>
            </tr>
            <tr>
              <td>全国</td>
              <td>12月26日</td>
              <td>语文  09:00-11:30</td>
              <td>数学（文理）  15:00-17:00</td>
            </tr>
            <tr>
              <td>全国</td>
              <td>12月27日</td>
              <td>文科综合/理科综合  09:00-11:30</td>
              <td>英语  15:00-17:00</td>
            </tr>
          </table>
          <p>阅卷规则详见<span class="red">附件1</span>。</p>
          <p>考试的各科考察范围及命卷细目详情见<span class="red">附件2</span>。</p>
          <p>诚挚邀请！</p>
          <div class="corporate-name">
            <img src="../../assets/img/img-seal.png" alt="" class="seal">
            <div class="name">
              <p>江西风向标教育科技有限公司</p>
              <p>2019年12月3日</p>
            </div>
          </div>
          <div class="down">
            <p>附件1:
              <a href="/static/lk-yj.PNG" target="_blank">教师线上阅卷规则说明(点击预览)</a>
            </p>
            <p>附件2:
              <a href="/static/lk-km.PNG" target="_blank">命卷细目表及各科考试安排(点击预览)</a>
            </p>
          </div>

        </div>
        <span class="btn-sing-up">我要报名</span>
        <img src="../../assets/img/img-sing-up-bottom.gif" class="img-sing-up-bottom" alt="">
      </div>
      <img src="../../assets/img/img-sing-up-right.gif" alt="">
    </div>

    <el-dialog title="填写报名资料" :visible.sync="signUpData" width="760px">
        <div class="sign-up-data">
          <p>请完善一下信息，我们的工作人员会及时联系您</p>
          <div class="row">
            <span class="left">学校
              <span class="red">*</span>
            </span>
            <el-input v-model="school_name" placeholder="请输入内容"></el-input>
          </div>
          <div class="row">
            <span class="left">姓名
              <span class="red">*</span>
            </span>
            <el-input v-model="userName" placeholder="请输入内容"></el-input>
          </div>
          <div class="row">
            <span class="left">手机
              <span class="red">*</span>
            </span><el-input v-model="mobile" placeholder="请输入内容" minlength="6" maxlength="11"></el-input>
          </div>
          <div class="row">
            <span class="left" style="vertical-align: top;">考试科目
            <span class="red">*</span>
            </span>
            <span class="subject-box">
              <el-checkbox-group v-model="subject">
                <el-checkbox label="语文"></el-checkbox>
                <el-checkbox label="数学(文)"></el-checkbox>
                <el-checkbox label="数学(理)"></el-checkbox>
                <el-checkbox label="英语"></el-checkbox>
                <el-checkbox label="文科综合"></el-checkbox>
                <el-checkbox label="理科综合"></el-checkbox>
              </el-checkbox-group>
            </span>

          </div>
          <div>
            <p class="red">注：不参加联考的科目请自行取消勾选</p>
          </div>
          <div style="text-align: center;">
            <span class="btn-add-sing-up" @click="save">提交</span>
          </div>
        </div>
    </el-dialog>

    <el-dialog title="提交成功" :visible.sync="signUpSuccess" width="760px">
     <div class="sign-up-success">
       <img src="../../assets/img/img-save-success.png" alt="">
       <div class="msg-box">
         <p class="big-msg">恭喜你！提交成功</p>
         <p class="msg">我们的工作人员将会及时联系您，并妥善保管您的相关信息！</p>
       </div>
     </div>
    </el-dialog>
  </div>
</template>

<script>
  import Http from '../../lib/Http.js'

  export default {
    name: "signUpList",
    data() {
      return {
        signUpData:false,
        subject:['语文','英语','数学(文)','文科综合','数学(理)','理科综合'],
        school_name:'',
        mobile:'',
        userName:'',
        signUpSuccess:false,
      }
    },
    created() {
      this.isPhone();
    },
    methods: {
      isPhone(){
        let go = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
        if(go){
          this.$router.push("/signUpListPhone")
        }
      },
      save(){
        let _this = this;
        let data ={
          subjects:'',
          school_name:this.school_name,
          mobile:this.mobile,
          userName:this.userName,
        }
        this.subject.forEach(i=>{
          data.subjects = data.subjects+i+','
        })

        if(this.school_name==''){
          this.$message.error('请填写学校名称');
          this.mobile = '';
          return false
        }
        if(this.userName==''){
          this.$message.error('请填写姓名');
          this.mobile = '';
          return false
        }
        if(!this.isPhoneNum(this.mobile)){
          this.$message.error('请填写正确的手机号码');
          this.mobile = '';
          return false
        }
        if(data.subjects==''){
          this.$message.error('请选择科目');
          this.mobile = '';
          return false
        }
        Http.Axios.post(`${Http.SIGN_UP_API_ROOT()}/rest/official_enroll/joint_sign`,data).then(function (res) {
          _this.signUpData = false;
          _this.signUpSuccess = true
        }).catch(function (err) {
          _this.$message.error('提交失败');
        });

      },
      isPhoneNum(str) {
        return /^(0|86|17951)?(13[0-9]|15[012356789]|16[0-9]|17[678]|18[0-9]|19[0-9]|14[57])[0-9]{8}$/.test(str)
      },
    },
  }
</script>

<style scoped lang="less">
  .red{
    color: #ff3600;
  }
.test-sign-up{
  .top{
    width: 1200px;
    margin: 0 auto;
  }
  .main{
    position: relative;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    margin-top: -3px;
    .content{
      padding: 0 24px;
      .title{
        margin-top: 32px;
        text-align: center;
      }
      .text{
        font-size: 14px;
        color: #393939;
        line-height: 28px;
        p{
          text-indent: 2em;
        }

        .text-title{
          font-size: 16px;
          font-weight: bold;
          text-indent: 0;
        }
      }
      .table-sing-up{
        margin-top: 10px;
        margin-bottom: 10px;
        margin-left: 28px;
        width: 1065px;
        text-align: center;
        border-color:#afccfa;
        .table-head{
          line-height: 40px;
          font-weight: bold;
          background-color: #afccfa;
          color: #5476db;

        }
        td{
          line-height: 50px;
        }
      }
    }
    .corporate-name{
      position: absolute;
      width: 1100px;
      text-align: right;
      z-index:1111;
      p{
        text-align: right;
      }
      .name{
        position: absolute;
        right: -16px;
        top:56px;
      }
    }
    .down{
      position: relative;
      top: 40px;
      color: #3c45fe;
      z-index: 1998;
      a{
        color: #3c45fe;
        text-decoration:underline;
      }
    }
  }
  .btn-sing-up{
    position: relative;
    display: inline-block;
    top: 50px;
    left: 50%;
    margin-left: -145px;
    width: 291px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    /*background:url("../../assets/img/bg-btn-sing-up.png");*/
    background: #cccccc;
    border-radius: 30px;
    cursor: not-allowed;
    z-index: 1999;
  }
  .img-sing-up-bottom{
    position: absolute;
    bottom: 0;
    left: 23px;
  }
}
  .sign-up-data{
    .row{
      margin-top: 13px;
      margin-bottom: 13px;
      .left{
        display: inline-block;
        width: 80px;
        padding-right: 20px;
        text-align: right;

      }
      .subject-box{
        display: inline-block;
        width: 580px;
      }
    }
    .btn-add-sing-up{
      position: relative;
      display: inline-block;
      width: 208px;
      height: 43px;
      line-height: 43px;
      text-align: center;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      background:url("../../assets/img/bg-btn-add-sing-up.png");
      cursor: pointer;
    }

  }
  .sign-up-success{
    text-align: center;
    .msg-box{
      display: inline-block;
      vertical-align: top;
      margin-top: 10px;
      margin-left: 20px;
      .big-msg{
        font-size: 28px;
        font-weight: bold;
        color: #000;
        text-align: left;
      }
      .msg{
        margin-top: 10px;
        font-size: 14px;
        font-weight: bold;
        color: #a9a9a9;
        text-align: left;
      }

    }
  }
  .btn-add{
    cursor: not-allowed;
  }
</style>


<style>
  .sign-up-data .el-input{
    width: 538px;

  }
  .sign-up-data .el-checkbox{
    width: 160px;
    margin-bottom: 26px;
  }
</style>




// WEBPACK FOOTER //
// signUpListTwo.vue?0bc67f2e